import { gql } from '@apollo/client';

export const FETCH_CHIESE = gql`
  query FetchChiese($where: ChieseWhereInput!) {
    chieses(where: $where) {
      edges {
        node {
          objectId
          nome
          alias
          citta
          frazione
          indirizzo
          cap
          provincia
          numero
        }
      }
    }
  }
`;
